import React, { useState, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import { getHelpsFile, getHelpsListDetail } from "src/api/request";
import { Collapse } from "antd";

const FileView = () => {
  const params = useParams();
  const history = useHistory();
  const [url, setUrl] = useState();
  const [url2, setUrl2] = useState();
  const [detaillist, setdetaillist] = useState([]);
  const { Panel } = Collapse;
  const [firstkey, setfirstkey] = useState(null);
  const myRef = useRef();
  const [fileType, setFileType] = useState();
  const [loading, setLoading] = useState(false);

  function callback(key) {
    setLoading(true);
    setUrl2(null);
    if (key) {
      const [id, furl] = key.split("*").map((str) => str.trim());
      const ftype = furl.split(".").pop();
      setFileType(ftype);
      getHelpsFile(id, params.id)
        .then((res) => {
          setLoading(false);
          setUrl(res.data);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    if (url !== undefined) {
      console.log("ene ajilj bn");
      const file = new Blob([url], {
        type: fileType === "pdf" ? "application/pdf" : "video/mp4",
      });
      const obj_url = URL.createObjectURL(file);
      setUrl2(obj_url);
    }
  }, [url]);

  useEffect(() => {
    getHelpsListDetail(params.id)
      .then((res) => {
        setdetaillist(res.data);
        setfirstkey(res.data[0].file_id);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [params.id]);
  return (
    <div className="card">
      <div className="card-header border-bottom">
        <button
          className="btn btn-outline-secondary"
          type="button"
          style={{ float: "left" }}
          onClick={() => {
            history.push("/help");
          }}
        >
          <i className="icon ion-ios-arrow-back" style={{ display: "block" }} />
        </button>
      </div>
      <div className="card">
        <div className="card-body">
          <Collapse defaultActiveKey={firstkey} accordion onChange={callback}>
            {detaillist.map((i, idx) => {
              return (
                <Panel header={i.filename} key={`${i.file_id} * ${i.filepath}`}>
                  {loading ? (
                    <div className="bg-red-500">Түр хүлээнэ үү ...</div>
                  ) : !url2 ? (
                    <div className="bg-red-500">Файл олдсонгүй !!!</div>
                  ) : (
                    <iframe
                      ref={myRef}
                      title="PDF"
                      frameBorder={0}
                      id="InViewer"
                      src={url2}
                      style={{
                        width: "100%",
                        height: window.innerWidth < 600 ? "450px" : "900px",
                      }}
                    />
                  )}
                </Panel>
              );
            })}
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default React.memo(FileView);
